import * as Sentry from "@sentry/browser";

Sentry.init({dsn: "https://17a766be243d431cb89d9487d11259fe@sentry.io/1299670"});

import "./helpers/polyfill";
import "./i18n";

// Filter lists i.e. on productsubcategories
const productList: HTMLElement | null = document.querySelector(".js-product-list-infinite");
const productListMoreButton: HTMLElement | null = document.querySelector(".js-more-exist");
if (productList !== null && productListMoreButton !== null) {
  import(/* webpackChunkName: "productList" */ "./components/productList").then((list) => {
    const x = new list.ProductList(productList, productListMoreButton);
  });
}

// Initialisierung Swiper Homepage
const bannerSection: HTMLElement | null = document.getElementById("BannerSection");
if (bannerSection !== null) {
  import(/* webpackChunkName: "BannerSwiper" */ "./components/swipers/rootBannerSection").then((banner) => {
    const _ = new banner.RootBannerSection(bannerSection);
  });
}

const flashsaleSection: HTMLElement | null = document.getElementById("FlashsaleSection");
if (flashsaleSection !== null) {
  Promise.all([
    import(/* webpackChunkName: "RootFlashsaleSwiper" */ "./components/swipers/rootFlashsaleSection"),
    import(/* webpackChankName: "loadFlashSale" */ "./components/loadFlashsales"),
  ]).then((imports) => {
    const {RootFlashsaleSection} = imports[0];
    const {LoadFlashsales} = imports[1];
    LoadFlashsales.load().then((flashSaleData) => {
      const _ = new RootFlashsaleSection(flashsaleSection, flashSaleData);
    });
  });
}

// Product slider in blog entries
const swiperProducts: NodeListOf<HTMLDivElement> | null = document.querySelectorAll(".swiper-products");
if (swiperProducts.length > 0) {
  import(/* webpackChunkName: "BlogProductSwiper" */ "./components/swipers/teaserSlider").then((tswp) => {
    swiperProducts.forEach((swiper) => {
      const _ = new tswp.TeaserSlider(swiper);
    });
  });
}

// Blog images, Coverflow style
const swiperBlogImages: NodeListOf<HTMLDivElement> = document.querySelectorAll(".swiper-blog-images");
if (swiperBlogImages.length > 0) {
  import(/* webpackChunkName: "BlogImageSwiper" */ "./components/swipers/blogImageSwiper").then((bi) => {
    swiperBlogImages.forEach((swiper) => {
      const _ = new bi.BlogImageSwiper(swiper);
    });
  });
}

// Shipping Steps auf der Kassenabschlussseite
const shippingSteps: HTMLDivElement | null = document.querySelector(".swiper-container-shippingsteps");
if (shippingSteps !== null) {
  import(/* webpackChunkName: "shippingSteps" */ "./components/swipers/shippingSteps").then((shipper) => {
    const _ = new shipper.ShippingSteps(shippingSteps);
  });
}

// Initialisierung Swiper Produktseiten
const swiperContainerProduct: Element = document.getElementsByClassName("swiper-container-product")[0];
const zoomAnchorList: HTMLCollectionOf<Element> = document.getElementsByClassName("gallery-zoom");
if (swiperContainerProduct !== null) {
  import(/* webpackChunkName: "ProductSwiper" */ "./components/swipers/productSwiper").then((prodSwiper) => {
    const _ = new prodSwiper.ProductSwiper(swiperContainerProduct, zoomAnchorList);
  });
}

// Initialisierung Swiper Blog-Einträge - Galerie
const gallerySwiper: HTMLDivElement | null = document.querySelector(".swiper-container-gallery");
if (gallerySwiper !== null) {
  import(/* webpackChunkName: "GallerySwiper" */ "./components/swipers/blogGallerySwiper").then((qallerySwp) => {
    const _ = new qallerySwp.BlogGallerySwiper(gallerySwiper);
  });
}

// Alle Swiper B-Waren-Seite
const galleryLinkCollection: HTMLCollectionOf<Element> = document.getElementsByClassName("gallery-link");
if (galleryLinkCollection.length > 0) {
  import(/* webpackChunkName: "BwareSwiper" */ "./components/swipers/bwareSwiper").then((bware) => {
    Array.from(galleryLinkCollection).forEach((anchor) => {
      const _ = new bware.BwareSwiper(anchor as HTMLAnchorElement);
    });
  });
}

// Sonstige Swiper suchen und initialisieren (zzt nur auf der ConnoxPlus welcome page )
const genericSwiper: NodeListOf<HTMLElement> = document.querySelectorAll(".swiper-container-generic");
if (genericSwiper.length > 0) {
  import(/* webpackChunkName: "GenericSwiper" */ "./components/swipers/genericSwiper").then((gSwiper) => {
    const _ = new gSwiper.GenericSwiper(genericSwiper);
  });
}

// Asynchronous stock loading
const stockInfoElements: NodeListOf<HTMLElement> | null = document.querySelectorAll("[data-react-stock]");
if (stockInfoElements.length >= 1) {
  import(/* webpackChunkName: "ItemStock" */ "./components/itemStockHandler").then((handler) => {
    handler.ItemStockHandler.run(stockInfoElements);
  });
}

// Asynchronous shoprating loading
const shopRatingElement: HTMLElement | null = document.querySelector("[data-react-rating]");
if (shopRatingElement) {
  import(/* webpackChunkName: "ShopRating" */ "./components/ShopRating/shopRatingHandler").then((handler) => {
    handler.ShopRatingHandler.run(shopRatingElement);
  });
}
